<template>
  <div class="text-muted">Doporučený počet vozidel: {{ carsCount }}</div>
</template>

<script setup>
import {defineProps, computed, defineEmits} from 'vue'

const props = defineProps(['weight'])
const emit = defineEmits(['update:carsCount'])
const WEIGHT_PER_CAR = 1000

const carsCount = computed(() => {
  const carCount = Math.ceil(props.weight / WEIGHT_PER_CAR)
  emit('update:carsCount', carCount)
  return carCount === 0 ? 1 : carCount
})

</script>

<style scoped>
</style>